export const EASY_CLOCKING_DEVICES_OFFLINE_LOAD = 'EASY_CLOCKING_DEVICES_OFFLINE_LOAD'
export const EASY_CLOCKING_DEVICES_OFFLINE_LOAD_PENDING =
  'EASY_CLOCKING_DEVICES_OFFLINE_LOAD_PENDING'
export const EASY_CLOCKING_DEVICES_OFFLINE_LOAD_FULFILLED =
  'EASY_CLOCKING_DEVICES_OFFLINE_LOAD_FULFILLED'
export const EASY_CLOCKING_DEVICES_OFFLINE_REJECTED = 'EASY_CLOCKING_DEVICES_OFFLINE_REJECTED'
